import { render, staticRenderFns } from "./ignore-customs-validation.vue?vue&type=template&id=65288850&scoped=true"
import script from "./ignore-customs-validation.vue?vue&type=script&lang=js"
export * from "./ignore-customs-validation.vue?vue&type=script&lang=js"
import style0 from "./ignore-customs-validation.vue?vue&type=style&index=0&id=65288850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65288850",
  null
  
)

export default component.exports